import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Logo, Panel, Btn } from "@/components/kit";
import api from "@/lib/api";

export default function Verify() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ status: "loading", message: "" });
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) { setState({ status: "error", message: "No verification token provided." }); return; }
    api.get(`/business/verify?token=${token}`)
      .then((r) => setState({ status: "ok", message: r.data.message }))
      .catch((e) => setState({ status: "error", message: e.response?.data?.detail || "Verification failed." }));
  }, [token]);

  return (
    <div className="bd-page flex flex-col items-center justify-center px-6 py-10">
      <Link to="/" className="mb-8"><Logo /></Link>
      <Panel className="w-full max-w-md p-8 text-center bd-fade-up" data-testid="verify-panel">
        {state.status === "loading" && <Loader2 className="mx-auto text-purple-300 animate-spin" size={48} />}
        {state.status === "ok" && <CheckCircle2 className="mx-auto text-emerald-400" size={48} />}
        {state.status === "error" && <XCircle className="mx-auto text-rose-400" size={48} />}
        <h1 className="font-head text-2xl font-bold text-white mt-4">
          {state.status === "loading" ? "Verifying…" : state.status === "ok" ? "Email verified" : "Verification failed"}
        </h1>
        <p className="text-sm text-purple-300/70 mt-2">{state.message}</p>
        {state.status !== "loading" && <Btn className="mt-6" data-testid="verify-continue" onClick={() => navigate("/admin")}>Go to my console</Btn>}
      </Panel>
    </div>
  );
}
